"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@emotion/core");

var react_1 = require("react");

exports.Box = react_1.forwardRef(function (props, ref) {
  return core_1.jsx("div", __assign({
    ref: ref,
    css: {
      boxSizing: 'border-box',
      position: 'relative'
    }
  }, props));
});